import React from "react";
import styled from "styled-components";
import "./css/Section.css";
import Fade from "react-reveal/Fade";
function Section({ title, description, leftbtn, rightbtn, backgroundImg }) {
  return (
    <Wrap bgImage={backgroundImg}>
      <Fade bottom>
        <ItemText>
          <h1>{title}</h1>
          <p>{description}</p>
        </ItemText>
      </Fade>

      <Buttons>
        <Fade bottom>
          <ButtonGroup className="btn">
            <LeftButton className="leftbtn">{leftbtn}</LeftButton>
            {rightbtn && <RightButton>{rightbtn}</RightButton>}
          </ButtonGroup>
        </Fade>
        <DownArrow src="images/down-arrow.svg" />
      </Buttons>
    </Wrap>
  );
}

export default Section;

const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: ${(props) => `url("./images/${props.bgImage}")`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
const ItemText = styled.div`
  padding-top: 15vh;
  text-align: center;
`;
const ButtonGroup = styled.div`
  display: flex;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const LeftButton = styled.div`
  margin: 8px;
  color: #fff;
  background-color: rgba(23, 26, 32, 0.8);
  height: 40px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  opacity: 1;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
`;
const RightButton = styled(LeftButton)`
  background-color: #fff;
  color: black;
`;
const DownArrow = styled.img`
  margin-left: 50%;
  margin-top: 20px;
  height: 40px;
  animation: animateDown infinite 1.5s;
  overflow: hidden;
  margin-bottom: 10px;
`;
const Buttons = styled.div``;
